<template>
  <div>
    <div class="content">
      <div class="head-title">
        赠送方式
      </div>
      <div class="give-way">
        <div class="item">
          <span>方式一：</span>
          点击页面屏幕右上角“...”转发给朋友
        </div>
        <div class="item">
          <span>方式二：</span>
          复制下面链接发送给朋友
        </div>
        <div class="link">
          <div class="left">
            {{url}}
          </div>
          <div
            class="button"
            @click="clipboard(url,$event)"
          >复制</div>
        </div>

        <div
          class="status-content"
          v-if="data?.sendGoodsInfo?.status!==0"
        >
          <div class="head-title">
            赠送状态
          </div>
          <div class="card">
            <div class="left">
              <img :src="data?.toUserInfo?.headimgurl">
            </div>
            <div class="right">
              <div class="title">{{data?.toUserInfo?.nickname}}</div>
              <div class="status">
                {{data?.sendGoodsInfo?.status===2 ? '已测试' : '未测试'}}
              </div>
            </div>
          </div>
          <div class="info">
            <div>领取订单：{{data?.goodsOrderInfo?.out_trade_no || '暂未测试'}}</div>
            <div>订单时间：{{data?.goodsOrderInfo?.create_time || '暂未测试'}}</div>

          </div>
        </div>

        <!-- 详情 -->
        <div class="goods-detail">
          <div class="left">
            <img :src="data?.goodsInfo?.goods_thumb_image">
          </div>
          <div class="right">
            <div class="title">{{data?.goodsInfo?.goods_subtitle}}</div>
            <div class="subhead">{{data?.goodsInfo?.goods_name}}</div>
          </div>
        </div>
        <div class="bottom">
          <div class="item">● {{data?.goodsInfo?.timu_count}}道精选问题</div>
          <div class="item">● {{data?.goodsInfo?.report_page_count}}页专业报告</div>
          <div class="item">● {{data?.goodsInfo?.goods_vr_sale_count}}人测过</div>
        </div>
      </div>
      <div class="head-title">
        平台介绍
      </div>
      <div class="introduce">
        {{about}}
      </div>
    </div>

    <div class="footer">
      <div
        class="button"
        @click="$router.go(-1)"
      >点这里返回上一页</div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, computed } from "vue";
import clipboard from "@/utils/clipboard";
import { useWx } from "@/hooks/useWx";
import { useStore } from "@/store";
export default {
  name: "giveDetail",

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const store = useStore();
    const state = reactive({
      show: false,
      url: window.location.href,
      status: ["未领取", "已领取", "已下单"],
    });
    const about = computed(() => store.getters.wechatInfo?.site?.site_jianjie);
    onMounted(async () => {
      useWx({ type: 3, guid: props.data?.goodsInfo?.guid, link: state.url });
    });

    return {
      ...toRefs(state),
      clipboard,
      about,
    };
  },
};
</script>

<style lang="less" scoped>
.content {
  padding: 5px @padding-base;
  .head-title {
    color: @theme-color;
    font-size: 18px;
    font-weight: bold;
    padding: @padding-base 0;
  }
  .give-way {
    .item {
      font-size: @font-size-base;
      line-height: 30px;
      span {
        color: @theme-color;
      }
    }
    .link {
      .space-between();
      font-size: @font-size-base;
      margin: @padding-sm 0;
      height: 38px;
      line-height: 38px;
      .left {
        border-radius: 3px;
        flex: 1;
        border: 1px solid #cfcfcf;
        overflow: hidden;
        padding: 0 @padding-sm;
      }
      .button {
        margin-left: 5px;
        width: 75px;
        border-radius: 3px;
        color: #fff;
        background-color: @theme-color;
        text-align: center;
      }
    }

    .status-content {
      .card {
        .space-between();
        border-radius: 5px;
        height: 80px;
        background-color: #f0f0f0;
        padding: @padding-sm;
        .left {
          height: 60px;
          width: 60px;
          border-radius: 50%;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .right {
          flex: 1;
          padding-left: @padding-base;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .title {
            font-size: @font-size-base;
          }
          .status {
            font-size: @font-size-lg;
            font-weight: bold;
            color: @theme-color;
          }
        }
      }
      .info {
        color: @gray-color;
        font-size: @font-size-sm;
        line-height: 25px;
        padding: @padding-sm 0;
      }
    }

    .goods-detail {
      .space-between();
      .left {
        width: 120px;
        img {
          width: 100%;
          border-radius: 5px;
        }
      }
      .right {
        padding-left: @padding-sm;
        flex: 1;
        .title {
          font-size: @font-size-lg;
          line-height: 25px;
          font-weight: bold;
        }
        .subhead {
          color: @gray-color;
          font-size: @font-size-base;
        }
      }
    }
    .bottom {
      .space-between();
      .item {
        flex: 1;
        color: @gray-color;
        text-align: center;
        font-size: @font-size-sm;
      }
    }
  }
  .introduce {
    font-size: 14px;
    line-height: 25px;
    color: @light-black;
  }
}
.footer {
  .fixed-bottom();
  display: flex;
  align-items: center;
  justify-content: center;
  .button {
    font-size: 18px;
    color: #fff;
    background-color: @theme-color;
    width: 90%;
    border-radius: 50px;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
}
</style>